import ContentPageTemplate from '@/components/ContentPageTemplate';
import { utilityPages } from '@/data/utilityPages';

export default function DisclaimerPage() {
  return <ContentPageTemplate page={utilityPages.disclaimer} />;
}
